import React, { PureComponent } from 'react';
import ImageRotator from '../ImageRotator';
import './RotateImageContainer.scss';

class RotateImageContainer extends PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.callImageRotation();
  }

  componentDidUpdate() {
    this.callImageRotation();
  }

  componentWillUnmount() {
    ImageRotator.unmount();
  }

  callImageRotation = () => {
    const { productData, gender } = this.props;
    const style = gender || productData?.frameDetails[0].value;
    ImageRotator.createImage('headturn-container', 'headturn', style);
  };

  render() {
    return (
      <div className="product-image-zoom">
        <div className="image-zoom" id="headturn-container">
          <img alt="180 degree view" id="headturn" src={this.props.rotateImgPath} />
        </div>
      </div>
    );
  }
}

export default RotateImageContainer;
